import { sdkConfig } from './config/index';

export type DeployEnv = 'LOCAL' | 'DEVELOPMENT' | 'STAGING' | 'PRODUCTION';

// Use the new configuration system
export const config = {
  SUBPATH: '',
  DEPLOY_ENV: sdkConfig.deploy_env.toUpperCase() as DeployEnv,
  AUTH_PROVIDER: sdkConfig.auth_provider,
  SERVER_URL: sdkConfig.serverUrl,
  // HTTP axios base — relative same-origin in local dev (drops CORS preflights),
  // absolute serverUrl when packaged/electron. See SDKConfig.httpBaseUrl.
  httpBaseUrl: sdkConfig.httpBaseUrl,
  WS_URL: sdkConfig.wsUrl,
  FLOWPAD_APP_HOST: sdkConfig.flowpad_app_host,
  FLOWPAD_APP_PORT: sdkConfig.flowpad_app_port,
  API_PREFIXES: sdkConfig.apiPrefixes,
  CHECK_REFRESH_TOKEN: sdkConfig.check_refresh_token,
  PREFILL_MESSAGE_QUERY_PARAM: 'prefill',
  LOGIN_QUERY_PARAM: 'login',
  SIGNUP_QUERY_PARAM: 'signup',
};

export default config;
